import React, { useState, useCallback, useEffect, useContext, useRef } from 'react'
import styled from 'styled-components';
import Chevron from './icons/Chevron';
import { Color, Colors } from '../styles/Colors';
import { AgendaContext } from '../context/AgendaContext';
import { CalendarButton } from '../styles/Buttons';
import CalendarIcon from './icons/CalendarIcon';
import { DateBtnContainer } from '../styles/Buttons';

const Wrapper = styled.div`
    position: relative; 
`

const Modal = styled.div`
    position: absolute;
    left: -285px; 
    top: 48px;
    background-color: transparent; 
    min-width: 600px; 
    width: 100%; 
    border-radius: 4px;
    z-index: 2001;  
    & > div {
        display: flex; 
        height: ${({$isVisible}) => $isVisible ? '370px' : '0'};
        visibility: ${({$isVisible}) => $isVisible ? 'visible' : 'hidden'};
        box-shadow: ${({$isVisible}) => $isVisible ? '8px 8px 8px rgba(0, 0, 0, 0.3)' : '0'};
        opacity: ${({$isVisible}) => $isVisible ? '1' : '0'};
        border-radius: 4px;
        background-color: ${Color(Colors.blue)};
        transition: height 0.5s ease-out, opacity 0.5s ease-out, box-shadow 0.5s ease-out, visibility 0.5s ease-out;

        & > div:first-of-type,
        & > div:last-of-type {
            flex: 1; 
            opacity: ${({$isVisible}) => $isVisible ? '1' : '0'};
            visibility: ${({$isVisible}) => $isVisible ? 'visible' : 'hidden'};
            transition: ${({$isVisible}) => $isVisible === true && 'opacity 0.5s 0.3s ease-out, visibility 0.5s 0.3s ease-out'};
            transition: ${({$isVisible}) => $isVisible === false && 'opacity 0.2s ease-out, visibility 0.0s ease-out'};

        }
        
    }
`;


const Months = styled.div`
    color: ${Color(Colors.white)};
    padding: 1rem;
    margin: 0.5rem 0 0 0; 

    // Month picker wrapper
    & > div:first-of-type {
        display: flex; 
        align-items: center;
        justify-content: space-between; 
        padding: 0 0 1rem 0; 
    }

    // Wrapper(s) for the days and dates
    & > div:nth-of-type(2),
    & > div:last-of-type {
        display: grid;
        grid-template-columns: repeat(7, 1fr);   
        justify-items: center;
        align-items: center;
        justify-content: center;
        align-content: center;
    }

    // Buttons for the dates
    & > div:last-of-type > button {
        display: flex;
        justify-content: center;
        align-items: center; 
        border: none; 
        background-color: ${Color(Colors.lightBlue)}; 
        color: ${Color(Colors.white)};
        padding: 0.5rem; 
        height: 28px;
        width: 28px;
        margin: 0.5rem;
    }
`;

const TimePicker = styled.div`
    padding: 1.45rem 0 0 0; 
    & > div {
        padding: 0 1rem 0 0; 
        & > label {
            color: ${Color(Colors.white)}; 
        }   
    }

`

const CustomSelect = styled.div`
    position: relative; 
    display: block;  

    &:after {
        content: ${({$isStartTime, $isEndTime}) => (($isStartTime || $isEndTime) ? '"▲"' : '"▼"')};
        position: absolute;
        top: 50%;
        right: 16px; 
        transform: translateY(-50%); 
        pointer-events: none; 
        color: ${Color(Colors.white)};
    }

    & > select {
        appearance: none; 
        width: 100%; 
        border: none; 
        border-radius: 4px; 
        cursor: pointer; 
        background-color: ${Color(Colors.lightBlue)}; 
        color: ${Color(Colors.white)}; 
        
        &:-ms-expand {
            display: none; 
        }

        &:focus {
            outline: 2px solid ${Color(Colors.white)}; 
        }
    }
`;

const DateNTimeComponent = ({ setError }) => {
    const [isStartTime, setIsStartTime] = useState(false); 
    const [isEndTime, setIsEndTime] = useState(false); 
    const {
        nextMeeting, setNextMeeting, selectedStartTime,
        setSelectedStartTime, selectedEndTime, setSelectedEndTime,
    } = useContext(AgendaContext);
    const [currentYear, setCurrentYear] = useState(() => {
        const saveCurrYear = localStorage.getItem('saveCurrYear_2');
        return saveCurrYear ? parseInt(saveCurrYear, 10) : new Date().getFullYear();
    });

    const [currentMonth, setCurrentMonth] = useState(() => {
        const saveCurrMonth = localStorage.getItem('saveCurrMonth_2');
        return saveCurrMonth ? parseInt(saveCurrMonth, 10) : new Date().getMonth();
    });

    const [selectedDate, setSelectedDate] = useState();
    const [isHovered, setIsHovered] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    const modalRef = useRef(null);

    const today = new Date();
    const thisYear = today.getFullYear(); 
    const thisMonth = today.getMonth();

    useEffect(() => {
        if (isVisible) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        }
    }, [isVisible])

    useEffect(() => {
        localStorage.setItem('saveCurrYear_2', currentYear);
        localStorage.setItem('saveCurrMonth_2', currentMonth);
        localStorage.setItem('next_meeting', JSON.stringify(nextMeeting));
        localStorage.setItem('meeting_start_time', JSON.stringify(selectedStartTime));
        localStorage.setItem('meeting_end_time', JSON.stringify(selectedEndTime));
    }, [currentYear, currentMonth, nextMeeting, selectedStartTime, selectedEndTime]);

    const timeOptions = [
        { value: '', label: '--:--', disabled: true },
        { value: '08:00', label: '08:00', disabled: false},
        { value: '08:15', label: '08:15', disabled: false},
        { value: '08:30', label: '08:30', disabled: false},
        { value: '08:45', label: '08:45', disabled: false},
        { value: '09:00', label: '09:00', disabled: false},
        { value: '09:15', label: '09:15', disabled: false},
        { value: '09:30', label: '09:30', disabled: false},
        { value: '09:45', label: '09:45', disabled: false},
        { value: '10:00', label: '10:00', disabled: false},
        { value: '10:15', label: '10:15', disabled: false},
        { value: '10:30', label: '10:30', disabled: false},
        { value: '10:45', label: '10:45', disabled: false},
        { value: '11:00', label: '11:00', disabled: false},
        { value: '11:15', label: '11:15', disabled: false},
        { value: '11:30', label: '11:30', disabled: false},
        { value: '11:45', label: '11:45', disabled: false},
        { value: '12:00', label: '12:00', disabled: false},
        { value: '12:15', label: '12:15', disabled: false},
        { value: '12:30', label: '12:30', disabled: false},
        { value: '12:45', label: '12:45', disabled: false},
        { value: '13:00', label: '13:00', disabled: false},
        { value: '13:15', label: '13:15', disabled: false},
        { value: '13:30', label: '13:30', disabled: false},
        { value: '13:45', label: '13:15', disabled: false},
        { value: '14:00', label: '14:00', disabled: false},
        { value: '14:15', label: '14:15', disabled: false},
        { value: '14:30', label: '14:30', disabled: false},
        { value: '14:45', label: '14:45', disabled: false},
        { value: '15:00', label: '15:00', disabled: false},
        { value: '15:15', label: '15:15', disabled: false},
        { value: '15:30', label: '15:30', disabled: false},
        { value: '15:45', label: '15:45', disabled: false},
        { value: '16:00', label: '16:00', disabled: false},
        { value: '16:15', label: '16:15', disabled: false},
        { value: '16:30', label: '16:30', disabled: false},
        { value: '16:45', label: '16:45', disabled: false},
        { value: '17:00', label: '17:00', disabled: false},
    ]

    const getFirstAndLastDays = (year, month) => {
        let firstDay = new Date(year, month, 1).getDay();
        firstDay = (firstDay === 0) ? 6 : firstDay - 1;
        const lastDay = new Date(year, month + 1, 0).getDate();

        return { firstDay, lastDay }
    }

    const generateDays = (year, month) => {
        const { lastDay, firstDay } = getFirstAndLastDays(year, month)
        const days = []

        for (let i = 0; i < firstDay; i++) {
            days.push(<button key={`empty-${i}`} disabled style={{ backgroundColor: 'transparent' }}></button>);
        }

        for (let day = 1; day <= lastDay; day++) {
            const paddedMonth = String(month + 1).padStart(2, '0');
            const paddedDay = String(day).padStart(2, '0')
            const dateOfDay = `${year}-${paddedMonth}-${paddedDay}`;
            const isNextMeeting = nextMeeting.includes(dateOfDay);
            days.push(
                <button
                    onClick={() => handleNextMeeting(dateOfDay)}
                    style={{
                        borderRadius: '6px',
                        border: isNextMeeting ? '2px solid #ff0000' : 'none',
                    }}
                    key={day}
                >
                    {day}
                </button>
            )
        }

        return days
    }

    const getYearInTheFuture = (year) => {
        const day = new Date()
        day.setFullYear(day.getFullYear() + year);
        return day.getFullYear()
    }

    /* const getYearInThePast = (year) => {
        const day = new Date()
        day.setFullYear(day.getFullYear() - year);
        return day.getFullYear()
    } */

    const handlePrevMonth = useCallback(() => {  
        if (currentYear === thisYear && currentMonth === thisMonth) return;

        if (currentMonth === 0) {
            setCurrentMonth(11)
            setCurrentYear(currentYear - 1)
        } else {
            setCurrentMonth(currentMonth - 1)
        }

    }, [currentYear, currentMonth])

    const handleNextMonth = useCallback(() => {
        const yearInTheFuture = getYearInTheFuture(2)
        if (currentYear === yearInTheFuture && currentMonth === thisMonth) return; 

        if (currentMonth === 11) {
            setCurrentMonth(0)
            setCurrentYear(currentYear + 1)
        } else {
            setCurrentMonth(currentMonth + 1)
        }
    }, [currentYear, currentMonth])

    const handleNextMeeting = (day) => {
        setSelectedDate(day);

        setNextMeeting((prev) => {
            if (prev.includes(day)) {
                return prev.filter(date => !date === selectedDate) // Remove date
            } else {
                return [day] // Add date
            }
        });

        if (day !== '') {
            setError(prevError => ({ ...prevError, nextMeeting: '' }))
        }
    };

    // Filter meetings endtime depending on the startdate 
    const filteredEndTimeOptions = timeOptions.filter(option => {
        if (!selectedStartTime) {
            return true;
        } else {
            return option.label === '--:--' || (!selectedStartTime || option.value > selectedStartTime) // show --:-- with the filtered endtimes 
        }
    })

    const toggleCalendar = (event) => {
        event.stopPropagation();
        setIsVisible(!isVisible);
    };

    const handleClickOutside = (event) => {
        if (modalRef.current && !modalRef.current.contains(event.target)) {
            setIsVisible(!isVisible);
        }
    };

    const handleMouseEnter = () => {
        setIsHovered(true)
    }

    const handleMouseLeave = () => {
        setIsHovered(false)
    }

    const calendarButtons = () => {
        const yearInTheFuture = getYearInTheFuture(2); 
        const isPast = (currentYear === thisYear) && (currentMonth === thisMonth); 
        const isToday = (currentYear === yearInTheFuture) && (currentMonth === thisMonth); 
 
        return(
            <DateBtnContainer $isPast={isPast} $isToday={isToday}>
                <button 
                    onClick={handlePrevMonth} 
                    aria-label="Previous Month"
                >
                    <Chevron />
                </button>
                <span>{new Date(currentYear, currentMonth).toLocaleString('default', { month: 'long' })} {currentYear}</span>
                <button onClick={handleNextMonth} aria-label="Next Month">
                    <Chevron />
                </button>
            </DateBtnContainer>
        )
    }

    const handleTimeStamp = () => {
        const date = (nextMeeting && (nextMeeting.length > 0)) ? nextMeeting[0] : 'YYYY-MM-DD'

        const startTime = selectedStartTime !== null ? selectedStartTime : '--:--'
        const endTime = selectedEndTime !== null ? selectedEndTime : '--:--' 

        return (
            <CalendarButton
                $isVisible={isVisible}
                $isHovered={isHovered}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                onClick={toggleCalendar}
            >
                <CalendarIcon />
                {`${date} | ${startTime} - ${endTime}`}
            </CalendarButton>
        )
    } 

    return (
        <Wrapper ref={modalRef}>
            {handleTimeStamp()}
            <Modal 
                $isVisible={isVisible}
            >
                <div>
                    <Months>
                        {calendarButtons()}
                        <div>
                            <div>Mån</div>
                            <div>Tis</div>
                            <div>Ons</div>
                            <div>Tors</div>
                            <div>Fre</div>
                            <div>Lör</div>
                            <div>Sön</div>
                        </div>
                        <div>
                            {generateDays(currentYear, currentMonth)}
                        </div>
                    </Months>
                    <TimePicker>
                        <div>
                            <label>Från:</label>
                            <CustomSelect $isStartTime={isStartTime}>
                                <select
                                    value={selectedStartTime || ''}
                                    onChange={(event) => setSelectedStartTime(event.target.value)}
                                    onFocus={() => setIsStartTime(true)}
                                    onBlur={() => setIsStartTime(false)}
                                >
                                    {timeOptions && timeOptions.map((option, index) => (
                                        <option
                                            key={index}
                                            value={option.value}
                                            disabled={option.disabled === true}
                                        >
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                            </CustomSelect>
                        </div>
                        <div>
                            <label>Till:</label>
                            <CustomSelect $isEndTime={isEndTime}>
                                <select
                                    value={selectedEndTime || ''}
                                    onChange={(event) => setSelectedEndTime(event.target.value)}
                                    onFocus={() => setIsEndTime(true)}
                                    onBlur={() => setIsEndTime(false)}
                                >
                                    {filteredEndTimeOptions && filteredEndTimeOptions.map((option) => (
                                        <option
                                            key={option.value}
                                            value={option.value}
                                            disabled={option.disabled === true}
                                        >
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                            </CustomSelect>
                        </div>
                    </TimePicker>
                </div>
            </Modal>
        </Wrapper>
    )
}

export default DateNTimeComponent